import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CalendarClock, ArrowRight } from "lucide-react";
import { useLang } from "@/i18n";
import { Reveal } from "@/components/Reveal";

const TARGET = new Date("2027-06-20T09:00:00+01:00").getTime();

function diff() {
  const now = Date.now();
  let s = Math.max(0, Math.floor((TARGET - now) / 1000));
  const days = Math.floor(s / 86400); s -= days * 86400;
  const hours = Math.floor(s / 3600); s -= hours * 3600;
  const minutes = Math.floor(s / 60); s -= minutes * 60;
  return { days, hours, minutes, seconds: s, done: TARGET - now <= 0 };
}

const Unit = ({ value, label, tid }) => (
  <div className="flex flex-col items-center" data-testid={`countdown-${tid}`}>
    <span className="font-serif text-4xl md:text-6xl text-ab-gold tabular-nums leading-none">
      {String(value).padStart(2, "0")}
    </span>
    <span className="mt-2 text-[0.65rem] md:text-xs tracking-[0.25em] uppercase text-ab-ivory/60">
      {label}
    </span>
  </div>
);

const Countdown = () => {
  const { tr } = useLang();
  const [t, setT] = useState(diff());

  useEffect(() => {
    const id = setInterval(() => setT(diff()), 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <section className="py-20 md:py-28 bg-ab-ebony border-y border-ab-gold/10 ab-grain relative" data-testid="home-countdown">
      <div className="ab-container max-w-4xl text-center relative z-10">
        <Reveal>
          <p className="ab-eyebrow mb-4 inline-flex items-center gap-2 justify-center">
            <CalendarClock size={15} className="text-ab-gold" />
            {tr({ fr: "Rendez-vous", en: "Save the date" })}
          </p>
          <h2 className="font-serif text-3xl md:text-5xl text-ab-ivory leading-tight">
            {tr({ fr: "Olympiades ANYANG BETI 2027", en: "ANYANG BETI Olympiad 2027" })}
          </h2>
          <p className="mt-4 text-ab-ivory/70 max-w-2xl mx-auto">
            {tr({
              fr: "Du 20 juin au 20 juillet 2027 — sports, danses et mvet pour rassembler les générations. Le compte à rebours est lancé.",
              en: "From 20 June to 20 July 2027 — sports, dances and mvet to bring generations together. The countdown has begun.",
            })}
          </p>

          {t.done ? (
            <p className="mt-10 font-serif text-2xl md:text-3xl text-ab-gold" data-testid="countdown-live">
              {tr({ fr: "C'est parti — les Olympiades ont commencé !", en: "It's on — the Olympiad has begun!" })}
            </p>
          ) : (
            <div className="mt-10 flex items-start justify-center gap-4 md:gap-10" data-testid="countdown-timer">
              <Unit value={t.days} tid="days" label={tr({ fr: "Jours", en: "Days" })} />
              <span className="font-serif text-3xl md:text-5xl text-ab-gold/40 leading-none">:</span>
              <Unit value={t.hours} tid="hours" label={tr({ fr: "Heures", en: "Hours" })} />
              <span className="font-serif text-3xl md:text-5xl text-ab-gold/40 leading-none">:</span>
              <Unit value={t.minutes} tid="minutes" label={tr({ fr: "Minutes", en: "Minutes" })} />
              <span className="font-serif text-3xl md:text-5xl text-ab-gold/40 leading-none">:</span>
              <Unit value={t.seconds} tid="seconds" label={tr({ fr: "Secondes", en: "Seconds" })} />
            </div>
          )}

          <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
            <Link to="/evenements" className="ab-btn-primary" data-testid="countdown-events-link">
              {tr({ fr: "Voir l'événement", en: "See the event" })} <ArrowRight size={15} />
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default Countdown;
